import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="public-empresas"
export default class extends Controller {
  connect() {
    window.quitar_animacion()
  }
}
